import { Checkbox } from '../../../components/ui/checkbox'
import { Label } from '../../../components/ui/label'
import { setDebugMode, useDebugModeAccess, useDebugModePreference } from '../../../lib/debug-mode'

/**
 * Compact debug-mode control for Settings → Advanced.
 * Returns null unless runtime config and the effective authz snapshot allow
 * debug access.
 */
export function DebugModeToggle() {
  const canAccessDebug = useDebugModeAccess()
  const debugModePreference = useDebugModePreference()
  if (!canAccessDebug) return null

  return (
    <Label
      htmlFor="settings-debug-mode"
      className="flex cursor-pointer items-start gap-2.5 rounded-md border border-border/70 bg-card px-3 py-2.5"
    >
      <Checkbox
        id="settings-debug-mode"
        checked={debugModePreference}
        onCheckedChange={(checked) => setDebugMode(checked === true)}
        className="mt-0.5"
      />
      <span className="flex min-w-0 flex-col gap-0.5">
        <span className="text-sm font-medium text-ink-2">Debug mode</span>
        <span className="text-11 font-normal leading-snug text-ink-3">
          Show developer tools: database consoles, Neo4j backup, ingest logs, tool traces,
          FactorySim load, and feature-flag overrides for global admins.
        </span>
      </span>
    </Label>
  )
}

/** Standalone wrapper — same control as {@link DebugModeToggle}. */
export function DebugModeCard() {
  return <DebugModeToggle />
}
